import React, { useState, useEffect, useContext } from 'react';
import { getUserById, editUser } from '../Services/userapis';
import { getValuesFromLocalstorage } from "../components/Helpers";
import LOCAL_KEYS, {
  parseLocalStorageJSON,
  setToLocalStorage,
} from "../helpers/localstorage";
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
// import './ProfileUpdate.css'; // Removed the CSS import
import Hoc from '../components/HOC';
import Loader from '../components/Loader';
import TextInput from '../components/TextInput';
import SelectInput from '../components/SelectInput';
import CustomDropdown from '../components/CustomDropdown';
import { LoginContext } from '../Context/Auth';
import { UserContext } from '../Context/User'; // Import UserContext


const ProfileUpdate = () => {
    const [userData, setUserData] = useState({
        fullName: '',
        email: '',
        gender: '',
        phone: '',
        addressLine1: '',
        addressLine2: '',
        city: '',
        state: '',
        country: '',
        zip: '',
        // acctType: '', // Remove acctType from state
    });

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [userId, setUserId] = useState(null);
    const [phoneError, setPhoneError] = useState('');
    const [zipError, setZipError] = useState('');
    const navigate = useNavigate();
    const {getProfilePhoto} = useContext(LoginContext);
    const { editUser: editUserFromContext, setCurrentUserDetails } = useContext(UserContext); // Get editUser and setCurrentUserDetails from UserContext

    // Use consistent profile photo
    // const getProfilePhoto = () => {
    //     const userDetails = parseLocalStorageJSON(LOCAL_KEYS.USER_DETAILS);
    //     // Get the first character of first and last name to determine an image number (for consistent results)
    //     const firstInitial = userDetails?.firstName?.charAt(0)?.toLowerCase() || 'a';
    //     const lastInitial = userDetails?.lastName?.charAt(0)?.toLowerCase() || 'b';
    //     const charCode1 = firstInitial.charCodeAt(0) || 97; // 'a' is 97
    //     const charCode2 = lastInitial.charCodeAt(0) || 98;  // 'b' is 98
        
    //     // Generate a gender and image number based on the user's name (for consistent results)
    //     const gender = (charCode1 % 2 === 0) ? 'men' : 'women';
    //     const imageNumber = ((charCode1 + charCode2) % 70) || 1; // RandomUser has ~70 images per category
        
    //     return {
    //         src: `https://randomuser.me/api/portraits/${gender}/${imageNumber}.jpg`,
    //         fallback: `https://ui-avatars.com/api/?name=${userDetails?.firstName || ''}+${userDetails?.lastName || ''}&background=2563EB&color=FFFFFF`
    //     };
    // };

    useEffect(() => {
        const userDetails = getValuesFromLocalstorage(LOCAL_KEYS.USER_DETAILS);
        if (userDetails && userDetails.id) {
            setUserId(userDetails.id);
        } else {
            setError("User ID not found. Please log in again.");
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        if (userId) {
            const fetchUserData = async () => {
                try {
                    const data = await getUserById(userId);
                    setUserData({
                        fullName: `${data.firstName || ''} ${data.lastName || ''}`.trim(),
                        email: data.email || '',
                        gender: data.gender || '',
                        phone: data.phone || '',
                        addressLine1: data.addressLine1 || '',
                        addressLine2: data.addressLine2 || '',
                        city: data.city || '',
                        state: data.state || '',
                        country: data.country || '',
                        zip: data.zip || '',
                        // acctType: data.acctType || '', // Remove acctType from fetched data
                    });
                } catch (err) {
                    setError('Failed to fetch user data.');
                    console.error('Error fetching user data:', err);
                } finally {
                    setLoading(false);
                }
            };

            fetchUserData();
        }
    }, [userId]);

    useEffect(() => {
        // Remove scroll prevention to allow scrolling on mobile
        // (No code needed here)
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setUserData(prevData => ({
            ...prevData,
            [name]: value
        }));

        if (name === "phone") {
            if (!/^[0-9]*$/.test(value)) {
                setPhoneError("Phone number can only contain digits.");
            } else if (value.length > 0 && value.length < 10) {
                setPhoneError("Phone number must be at least 10 digits.");
            } else if (value.length > 13) {
                setPhoneError("Phone number cannot exceed 13 digits.");
            } else {
                setPhoneError('');
            }
        }
        
        if (name === "zip") {
            if (!/^[0-9]*$/.test(value)) {
                setZipError("Postal code can only contain digits.");
            } else if (userData.country === "USA" && value.length !== 5) {
                setZipError("For USA, postal code must be exactly 5 digits.");
            } else if (userData.country === "IND" && value.length !== 6) {
                setZipError("For India, postal code must be exactly 6 digits.");
            } else {
                setZipError('');
            }
        }
        // If country is changed, revalidate zip
        if (name === "country") {
            const zip = userData.zip;
            if (value === "USA" && zip && zip.length !== 5) {
                setZipError("For USA, postal code must be exactly 5 digits.");
            } else if (value === "IND" && zip && zip.length !== 6) {
                setZipError("For India, postal code must be exactly 6 digits.");
            } else {
                setZipError("");
            }
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const currentData = await getUserById(userId);
            const dataToSend = { ...currentData }; // Start with all original data from backend

            // Handle fullName conversion to firstName and lastName
            const nameParts = userData.fullName.split(' ');
            dataToSend.firstName = nameParts[0] || '';
            dataToSend.lastName = nameParts.slice(1).join(' ') || '';
            
            // Compare and update only truly changed fields from the form
            for (const key in userData) {
                if (key !== 'fullName' && userData[key] !== currentData[key]) {
                    dataToSend[key] = userData[key];
                }
            }

            // Ensure acctType is always sent, and uses currentData if not changed in form
            // This logic is simplified as acctType is no longer directly managed by the form state
            // Ensure it's still present in dataToSend if it was in currentData
            if (currentData.acctType && !dataToSend.acctType) {
                dataToSend.acctType = currentData.acctType;
            }

           let responce = await editUserFromContext(userId, dataToSend);
            toast.success('Profile updated successfully!');
            setToLocalStorage(LOCAL_KEYS.USER_DETAILS, responce);
            setCurrentUserDetails(responce);
            navigate('/profile-update'); // Corrected redirect path
        } catch (err) {
            setError('Failed to update profile.');
            console.error('Error updating user data:', err);
            toast.error(err.response?.data?.message || 'Failed to update profile.'); // Show specific backend error if available
            navigate('/profile-update'); // Corrected redirect to profile page on error
        }
    };

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <div className="flex flex-col bg-white rounded-lg shadow-lg w-full max-w-lg sm:max-w-xl md:max-w-2xl lg:max-w-3xl mx-auto my-4 sm:my-8 md:my-12 font-sans text-gray-700 overflow-y-auto max-h-[100vh]">
            <Loader isLoading={loading} />
            <div className="p-4 sm:p-6 md:p-8 border-b border-gray-200">
                <h2 className="m-0 text-2xl font-semibold text-gray-800 text-center">Edit Profile</h2>
            </div>
            <div className="flex flex-col md:flex-row p-4 sm:p-6 md:p-8 gap-4 md:gap-6">
                <div className="flex-shrink-0 relative w-28 h-28 sm:w-36 sm:h-36 rounded-full overflow-hidden border border-gray-200 flex justify-center items-center mx-auto md:mx-0 mb-4 md:mb-0">
                    <img src={getProfilePhoto().src} onError={(e) => { e.target.onerror = null; e.target.src = getProfilePhoto().fallback; }} alt="User Avatar" className="w-full h-full object-cover" />
                    <div className="absolute bottom-2 right-2 bg-blue-600 text-white rounded-full p-2 cursor-pointer flex justify-center items-center text-sm shadow-md">✏️</div>
                </div>
                <form onSubmit={handleSubmit} className="flex-grow grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-4">
                    <div className="flex flex-col">
                        
                        <TextInput
                            name="fullName"
                            value={userData.fullName}
                            handleChange={handleChange}
                            placeholder="Full Name"
                            legend={true}
                            required
                        />
                    </div>
                    <div className="flex flex-col">
                        
                        <TextInput
                            name="email"
                            value={userData.email}
                            handleChange={handleChange}
                            placeholder="Email"
                            legend={true}
                            isDisabled={true}
                            required
                        />
                    </div>
                    <div className="flex flex-col">
                        
                        <CustomDropdown
                            name="gender"
                            value={[
                                { value: 'M', label: 'Male' },
                                { value: 'F', label: 'Female' }
                            ].find(option => option.value === userData.gender) || null}
                            handleChange={(selectedOption) => handleChange({
                                target: {
                                    name: "gender",
                                    value: selectedOption.value
                                }
                            })}
                            placeholder="Gender"
                            options={[
                                { value: 'M', label: 'Male' },
                                { value: 'F', label: 'Female' }
                            ]}
                            handleGetOptionValue={(option) => option.value}
                            handleGetOptionName={(option) => option.label}
                            required
                        />
                    </div>
                    <div className="flex flex-col">
                        
                        <TextInput
                            name="phone"
                            value={userData.phone}
                            handleChange={handleChange}
                            placeholder="Phone Number"
                            type="tel"
                            legend={true}
                            pattern="[0-9]{10,13}"
                            maxLength="13"
                            required
                        />
                        {phoneError && <p className="text-red-500 text-xs mt-1">{phoneError}</p>}
                    </div>
                    <div className="flex flex-col">
                        
                        <TextInput
                            name="addressLine1"
                            value={userData.addressLine1}
                            handleChange={handleChange}
                            placeholder="Address Line 1"
                            legend={true}
                            required
                        />
                    </div>
                    <div className="flex flex-col">
                        
                        <TextInput
                            name="addressLine2"
                            value={userData.addressLine2}
                            handleChange={handleChange}
                            placeholder="Address Line 2"
                            legend={true}
                        />
                    </div>
                    <div className="flex flex-col">
                        
                        <TextInput
                            name="city"
                            value={userData.city}
                            handleChange={handleChange}
                            placeholder="City"
                            legend={true}
                            required
                        />
                    </div>
                    <div className="flex flex-col">
                        
                        <TextInput
                            name="state"
                            value={userData.state}
                            handleChange={handleChange}
                            placeholder="State"
                            legend={true}
                            required
                        />
                    </div>
                    <div className="flex flex-col">
                        
                        <TextInput
                            name="zip"
                            value={userData.zip}
                            handleChange={handleChange}
                            placeholder="Postal Code"
                            legend={true}
                            pattern={userData.country === "USA" ? "[0-9]{5}" : userData.country === "IND" ? "[0-9]{6}" : "[0-9]*"}
                            maxLength={userData.country === "USA" ? 5 : userData.country === "IND" ? 6 : 6}
                            required
                        />
                        {zipError && <p className="text-red-500 text-xs mt-1">{zipError}</p>}
                    </div>
                    <div className="flex flex-col">
                        
                        <CustomDropdown
                            name="country"
                            value={[
                                { value: 'IND', label: 'IND' },
                                { value: 'USA', label: 'USA' }
                            ].find(option => option.value === userData.country) || null}
                            handleChange={(selectedOption) => handleChange({
                                target: {
                                    name: "country",
                                    value: selectedOption.value
                                }
                            })}
                            placeholder="Country"
                            options={[
                                { value: 'IND', label: 'IND' },
                                { value: 'USA', label: 'USA' }
                            ]}
                            handleGetOptionValue={(option) => option.value}
                            handleGetOptionName={(option) => option.label}
                            required
                        />
                    </div>
                    
                    <div className="col-span-1 md:col-span-2 flex justify-end pt-1 mt-1">
                        <button type="submit" className="bg-blue-600 text-white py-3 px-6 rounded-md text-base font-semibold transition-colors duration-300 hover:bg-blue-700 w-full md:w-auto">Save</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Hoc(ProfileUpdate); 